<template>
    <v-app>
        <v-app-bar fixed color="primary" elevate-on-scroll dense dark>
            <v-row>
                <v-col class="pl-15">
                    <span class="mr-15">LOGO</span>
                    MEGATALKING
                </v-col>
                <v-col class="text-right pr-15" v-if="$vuetify.breakpoint.mdAndUp">
                    <a href="#">Link 1</a>
                    <a href="#">Link 2</a>
                    <a href="#">Link 3</a>
                    <a href="#">Link 4</a>
                    <a href="#">Link 5</a>
                </v-col>
            </v-row>
        </v-app-bar>
        <v-row class="mt-10">
            <v-col class="pa-10" :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12">
                <div class="ma-10">
                    <h1 class="blue--text">Introduction</h1>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus reprehenderit perspiciatis exercitationem nesciunt sit, officia, quod velit esse, delectus perferendis deleniti dolorum impedit quisquam assumenda ad expedita ratione at eum.</p>
                </div>
            </v-col>
            <v-col cols="6" class="pa-10" v-if="$vuetify.breakpoint.mdAndUp">
                <v-container>
                    <v-carousel height="400">
                        <v-carousel-item
                            v-for="(item,i) in items"
                            :key="i"
                            :src="item.src"
                        ></v-carousel-item>
                    </v-carousel>
                </v-container>
            </v-col>
        </v-row>
        <v-container class="mt-15">
            <h3 class="text-center mb-3 blue--text" :class="demoTitles">YOUTUBE (VIDEO MATERIAL)</h3>
            <v-row>
                <v-col v-for="(material, index) in youtube" :key="material.id" :cols="$vuetify.breakpoint.smAndDown ? 12 : ''">
                    <v-img
                        :src="material.src"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        style="cursor: pointer"
                        @click="openYoutubeUnitSelection(index)"
                    >
                        <div class="img-overlay">{{ material.name }}</div>
                    </v-img>
                </v-col>
            </v-row>

            <h3 class="text-center mt-10 mb-3 blue--text" :class="demoTitles">WEB BOOKS</h3>
            <v-row>
                <v-col v-for="book in webBooks" :key="book.id" :cols="$vuetify.breakpoint.smAndDown ? 12 : ''">
                    <v-img
                        :src="book.src"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        @click="demoWebbook(book.id)"
                        style="cursor: pointer"
                    >
                        <div class="img-overlay">{{ book.name }}</div>
                    </v-img>
                </v-col>
            </v-row>

            <v-row style="background: #5cadf0;" class="pa-3 my-5">
                <div class="mx-10">Twitter Feed</div>
            </v-row>
        </v-container>

        <v-footer color="primary lighten-1">
            <v-container>
                <div class="text-center white--text">
                    All Rights Reserved. Megatalking 2022
                </div>
            </v-container>
        </v-footer>

        <v-dialog v-model="dialog.show" width="400">
            <v-card class="pa-5">
                <h2 class="blue--text text-center mb-2">{{ dialog.title }}</h2>
                <div class="grey--text text-center">Choose one from the list below</div>
                <v-list>
                    <v-list-item-group>
                        <v-list-item v-for="(unit, index) in youtube[dialog.youtube].units" :key="index">
                            <v-list-item-content @click="demoYoutube(unit.id)" class="content">
                                <v-list-item-title>{{ unit.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
export default {
    data () {
        return {
            dialog: {
                show: false,
                title: null,
                youtube: 0
            },
            items: [
                {
                    src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
                },
                {
                    src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
                },
                {
                    src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
                },
                {
                    src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
                }
            ],
            webBooks: [
                {
                    id: 68,
                    name: "Freetalking QnA",
                    src: require("@/assets/images/demo/freetalking.webp")
                },
                {
                    id: 78,
                    name: "Discussion and Analysis",
                    src: require("@/assets/images/demo/speaking-pattern.jpg")
                },
                {
                    id: 51,
                    name: "Business English",
                    src: require("@/assets/images/demo/business-dialogue.jpg")
                }

            ],
            youtube: [
                {
                    name: "Celebrity Talk Show",
                    src: require("@/assets/images/demo/celebrity-talk-show.jpg"),
                    units: [
                        {
                            id: 67,
                            title: "Robert Downey Jr.-TODAY"
                        },
                        {
                            id: 70,
                            title: "Will Smith-Quiknugs TV"
                        },
                        {
                            id: 75,
                            title: "Ryan Gosling-MadeinHollywoodTV"
                        }
                    ]
                },
                {
                    name: "Ted Ed",
                    src: require("@/assets/images/demo/teded.png"),
                    units: [
                        {
                            id: 6,
                            title: "Unit 6: How the food you eat affects your brain."
                        },
                        {
                            id: 10,
                            title: "Unit 10: Should you trust your first impression?"
                        },
                        {
                            id: 15,
                            title: "Unit 15: 3 tips to boost your confidence."
                        }
                    ]
                },
                {
                    name: "Movies",
                    src: require("@/assets/images/demo/movies.jpeg"),
                    units: [
                        {
                            id: 24,
                            title: "Movie 4 - 비포 선셋"
                        },
                        {
                            id: 30,
                            title: "Movie 10 - 크레이지 리치 아시안"
                        },
                        {
                            id: 38,
                            title: "Movie 18 - 이지 A"
                        }
                    ]
                }
            ]
        }
    },
    computed: {
        demoTitles () {
            return this.$vuetify.breakpoint.smAndDown ? "title-mobile" : "title-large"
        }
    },
    mounted () {
        if (localStorage.getItem(process.env.VUE_APP_STORAGE_NAME) == null) {
            const userData = {
                id: 500,
                userType: "guest",
                client: "guest"
            }
            localStorage.setItem(process.env.VUE_APP_STORAGE_NAME, JSON.stringify(userData))
        }
    },
    methods: {
        openYoutubeUnitSelection (index) {
            this.dialog.title = this.youtube[index].name
            this.dialog.youtube = index
            this.dialog.show = true
        },
        demoWebbook (bookId) {
            this.$router.push({ name: "Preview", query: { bookid: bookId, title: "Interview English" } })
        },
        demoYoutube (unitId) {
            location.href = "https://ueducms.org/content-management/dist/#/preview/material/" + unitId
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
    margin-right: 30px;
    font-size: 1rem;
    color: #fff;
}
.img-overlay {
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    text-align: center;
    padding: 5px;
    color: #fff;
    position: absolute;
    bottom: 0;
}
.title-mobile {
    font-size: 2rem;
    margin-top: 10px;
}

.title-large {
    font-size: 1.5rem;
}

.content {
    padding-left: 10;
    cursor: pointer;
}
</style>
